
import { processDynamicFields } from '@/components/cost-center/document-defaults/dynamicFieldProcessor';
import { format } from 'date-fns';

// Format phone number to xxx xxx xxxx format
export const formatPhoneNumber = (phone: string | undefined): string => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length >= 10) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
  }
  return phone;
};

// Generate dynamic footer text for invoices
export const generateInvoiceFooterText = (invoiceData: any, documentDefaults: any): string => {
  if (documentDefaults?.invoice_footer) {
    const today = format(new Date(), 'dd MMMM yyyy');
    
    return processDynamicFields(documentDefaults.invoice_footer, {
      user: {
        first_name: invoiceData?.userProfile?.first_name,
        last_name: invoiceData?.userProfile?.last_name,
        email: invoiceData?.userProfile?.email,
        personal_phone_number: invoiceData?.userProfile?.personal_phone_number,
      },
      company: {
        name: invoiceData?.company?.name,
        email: invoiceData?.company?.email,
        company_phone_number: invoiceData?.company?.company_phone_number,
        street_address: invoiceData?.company?.street_address,
        suburb: invoiceData?.company?.suburb,
        city: invoiceData?.company?.city,
        province_state: invoiceData?.company?.province_state,
        postal_code: invoiceData?.company?.postal_code,
        website: invoiceData?.company?.website,
        bank_name: invoiceData?.company?.["Bank Name"],
        branch_name: invoiceData?.company?.["Branch Name"],
        branch_code: invoiceData?.company?.["Branch Code"],
        account_number: invoiceData?.company?.["Account Number"],
        account_holder: invoiceData?.company?.["Account Holder"],
      },
      customer: {
        name: [invoiceData?.customer?.name, invoiceData?.customer?.last_name].filter(Boolean).join(' '),
        first_name: invoiceData?.customer?.name,
        last_name: invoiceData?.customer?.last_name,
        email: invoiceData?.customer?.emails?.[0],
        cell_numbers: invoiceData?.customer?.cell_numbers,
        street_address: invoiceData?.customer?.street_address,
        suburb: invoiceData?.customer?.suburb,
        city: invoiceData?.customer?.city,
        province_state: invoiceData?.customer?.province_state,
        postal_code: invoiceData?.customer?.postal_code,
      },
      invoice: {
        invoice_number: invoiceData?.invoice?.invoice_number,
        invoice_date: (() => {
          const d = invoiceData?.invoice?.invoice_date || invoiceData?.invoice?.created_at;
          try { return d ? format(new Date(d), 'dd MMMM yyyy') : ''; } catch { return ''; }
        })(),
        due_date: invoiceData?.invoice?.due_date 
          ? format(new Date(invoiceData.invoice.due_date), 'dd MMMM yyyy') 
          : '',
      },
      estimate: {
        estimate_number: invoiceData?.estimate?.estimate_number || '',
        created_date: invoiceData?.estimate?.created_at 
          ? format(new Date(invoiceData.estimate.created_at), 'dd MMMM yyyy') 
          : '',
        expires_date: invoiceData?.estimate?.expires_at 
          ? format(new Date(invoiceData.estimate.expires_at), 'dd MMMM yyyy') 
          : '',
        validity_days: invoiceData?.estimate?.validity_period?.toString() || '',
      },
      system: {
        today_date: today,
      }
    });
  }
  
  // Default footer text
  let defaultFooter = `Payment terms: ${invoiceData?.invoice?.payment_terms || 'Net 30 days'}.`;
  
  if (invoiceData?.company?.company_phone_number) {
    defaultFooter += ` For queries contact us on ${formatPhoneNumber(invoiceData.company.company_phone_number)}`;
  }
  
  if (invoiceData?.company?.email) {
    defaultFooter += ` or email us on ${invoiceData.company.email}`;
  }
  
  if (invoiceData?.userProfile?.first_name && invoiceData?.userProfile?.personal_phone_number) {
    defaultFooter += ` or contact ${invoiceData.userProfile.first_name} on ${formatPhoneNumber(invoiceData.userProfile.personal_phone_number)}`;
  }
  
  defaultFooter += '.';
  return defaultFooter;
};
